<div
  class="main-bar-container"
  fxLayout="row"
  fxLayoutAlign="space-between center"
>
  <div class="bar">
    <a
      class="team-name"
      [routerLink]="['/teams/', item.id]"
      [matTooltip]="item.name"
      >{{ item.name }}</a
    >
    <div fxLayout="row" fxLayoutAlign="start center">
      <mat-progress-bar
        [ngClass]="{
          'red-bar': acceptedSeatsPercentage <= 19,
          'yellow-bar':
            acceptedSeatsPercentage > 19 && acceptedSeatsPercentage <= 80,
          'green-bar': acceptedSeatsPercentage > 80
        }"
        [value]="acceptedSeatsPercentage"
      ></mat-progress-bar>
      <p class="bar-lable">
        {{ item.summary.accepted }} of {{ item.summary.roster }} accepted
      </p>
    </div>
  </div>
  <p class="status">Starts {{ teamStartsIn }}</p>
</div>
